export const MOBILE_HEADER_OFFSET = 272

export const DEFAULT_PROPS = {
  itemHeight: 40,
  maxVisibleItems: 8,
  inputPlaceholder: 'Search...',
  values: [],
}

export const MOBILE_BREAKPOINT = '(max-width: 768px)'
